import {sentinelMw} from '../api';

export const gboRefDataResource = {
    api: sentinelMw,
    url: 'firms/pull-from-gbo',
    useCache: false,
    parseResponse: ({data}) => data,
    defaultValue: {}
};
